import { AppKind } from "common/components/app-kind";
import { getLocalizedString } from "common/components/localization";
import { useNetworkStatus } from "hooks/use-network-status";
import { Container, SubTitle, Title } from "./offline-banner-style";

const OfflineBanner: React.FunctionComponent = () => {
    const onLine = useNetworkStatus();

    if (onLine) {
        return null;
    }

    return (
        <Container>
            <Title>{getLocalizedString("youAreOffline", AppKind.App)}</Title>
            <SubTitle>{getLocalizedString("youAreOfflineSubtitle", AppKind.App)}</SubTitle>
        </Container>
    );
};

export default OfflineBanner;
